import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome'

export type OdinIconProps = FontAwesomeIconProps

// FontAwesome passthrough wrapper. All Odin icons go through here.
export function OdinIcon(props: OdinIconProps) {
  return <FontAwesomeIcon {...props} />
}
